import axios from "axios";
import Config from "../utils/Config";

class TradingPartnerService{
    config = {
        headers: {
            Authorization: "",
            GroupId: "",
            CompanyId: "",
        },
    };

    setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
    }

    //create trading rartner
    async createTradingPartner (accessToken, groupId, companyId, formData){
        this.setAccessToken(accessToken, groupId, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + "/api/tradingPartner", //api/tradingPartner
            formData,
            this.config
        )
        return data.data;
    }

    //update trading rartner
    async updateTradingPartner (accessToken, groupId, companyId, tradingPartnerId, formData){
        this.setAccessToken(accessToken, groupId, companyId);

        const data = await axios.put(
            Config.BACKEND_URL + `/api/tradingPartner/${tradingPartnerId}`, //api/tradingPartner/{tradingPartnerId}
            formData,
            this.config
        )
        return data.data;
    }

    //get trading partner by group id
    async getTradingPartnerByGroupId (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/tradingPartner/byGroup/${groupId}`, //api/tradingPartner/byGroup/{groupId}
                this.config
            )
            return data.data;
        }

    //get trading partner by id
    async getTradingPartnerById (accessToken, groupId, companyId, tradingPartnerId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/tradingPartner/${tradingPartnerId}`, //api/tradingPartner/id
                this.config
            )
            return data.data;
        }
    
    //lhdn tin number validation
    async getLhdnTinNumberValidation (accessToken, groupId, companyId, tin, idType, idValue){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/LhdnApi/validateTIN?tin=${tin}&idType=${idType}&idValue=${idValue}`, //api/LhdnApi/validateTIN?tin=C26388347070&idType=Business registration number&idValue=201901039988
                this.config
            )
            return data.data;
        }

    // get country codes
    async getCountryCodes (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + "/api/data/country-codes", //api/data/country-codes
                this.config
            )
            return data.data;
        }

    // get state codes
    async getStateCodes (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + "/api/data/state-codes", //api/data/state-codes
                this.config
            )
            return data.data;
        }
    
    // get msci codes
    async getMsciCodes (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + "/api/data/msic-codes", ///api/data/msic-codes
                this.config
            )
            console.log("MSCI codes API",data.data)
            return data.data;
        }

    //csv upload
    async csvUpload (accessToken, groupId, companyId, formData){
        this.setAccessToken(accessToken, groupId, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/tradingPartner/csvUpload/${groupId}/${companyId}`, //api/tradingPartner/csvUpload/{groupId}/{companyId}
            formData,
            this.config
        )
        return data.data;
    }

    async GetClassificationCodes (accessToken, groupId, companyId)
      {
        this.setAccessToken(accessToken,groupId,companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/data/classification-codes`, 
          this.config
      )
      return data.data;

      }
}

export default new TradingPartnerService();